module.exports = __webpack_public_path__ + "img/IMG_3539_L_BlackMatted_MockedUp.4db0278b.jpg";